import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Loader2, CreditCard, ExternalLink, CheckCircle2 } from 'lucide-react';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { UsageQuotasCard } from '@/components/settings/UsageQuotasCard';

export default function SubscriptionSettings() {
  const {
    loading,
    planName,
    status,
    periodEnd,
    subscribed,
  } = useSubscription();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const isActive = status === 'active' || status === 'trialing';

  return (
    <div className="space-y-6">
      {/* Card abonnement */}
      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <CreditCard className="w-5 h-5 text-primary" />
            </div>
            <div>
              <CardTitle>Mon abonnement</CardTitle>
              <CardDescription>
                Gérez votre abonnement et votre facturation
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Plan actuel */}
          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center justify-between mb-4">
              <div>
                <p className="text-sm text-muted-foreground">Plan actuel</p>
                <p className="text-2xl font-bold">{planName}</p>
              </div>
              <Badge variant={isActive ? 'default' : 'secondary'}>
                {isActive ? (
                  <>
                    <CheckCircle2 className="w-3 h-3 mr-1" />
                    Actif
                  </>
                ) : (
                  'Inactif'
                )}
              </Badge>
            </div>

            {periodEnd && (
              <p className="text-sm text-muted-foreground">
                Prochain renouvellement : {new Date(periodEnd).toLocaleDateString('fr-FR', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}
              </p>
            )}
          </div>

          {/* Actions */}
          <div className="flex flex-wrap gap-3">
            <Button asChild>
              <Link to="/subscription">
                <ExternalLink className="w-4 h-4 mr-2" />
                Gérer mon abonnement
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Card quotas d'utilisation */}
      <UsageQuotasCard />
    </div>
  );
}
